import APP_ACTIONS from '../constants/app-actions';

const initialState = {};

const auth = (state = initialState, action) => {
    switch (action.type) {
    case APP_ACTIONS.LOGIN:
        return { ...action.payload };
    case APP_ACTIONS.LOGOUT:
        return initialState;
    default:
        return state;
    }
};

export default auth;



/** WEBPACK FOOTER **
 ** ./src/reducers/auth.js
 **/